// SVG path string generators for chart markers.

export function trianglePath(
    cx: number,
    cy: number,
    size: number,
    up: boolean
): string {
    return up
        ? `M${cx},${cy - size} L${cx - size * 0.87},${cy + size * 0.5} L${cx + size * 0.87},${cy + size * 0.5} Z`
        : `M${cx},${cy + size} L${cx - size * 0.87},${cy - size * 0.5} L${cx + size * 0.87},${cy - size * 0.5} Z`;
}

export function diamondPath(cx: number, cy: number, size: number): string {
    return `M${cx},${cy - size} L${cx + size * 0.7},${cy} L${cx},${cy + size} L${cx - size * 0.7},${cy} Z`;
}

/** Return the SVG path string for a direction-based marker */
export function markerPath(
    cx: number,
    cy: number,
    size: number,
    direction: string | null
): string {
    if (direction === 'bullish') return trianglePath(cx, cy, size, true);
    if (direction === 'bearish') return trianglePath(cx, cy, size, false);
    return diamondPath(cx, cy, size);
}
